import { IMuiTextField } from 'components/widgets/mui-text-field/TextField';
import { useMemo } from 'react';
import useStyle from '../../../../widgets/mui-text-field/styles';

export const UseStyleHook = () => {
    const classes = useStyle();

    const style = useMemo(
        () => ({
            InputProps: {
                classes: {
                    root: classes.accountForm,
                    focused: classes.accountFormFocused,
                    notchedOutline: classes.accountFormNotchedOutline,
                },
            },
            inputSelectProps: {},
            InputLabelProps: {
                classes: {
                    root: classes.accountFormLabel,
                    focused: classes.accountFormLabelFocused,
                },
            },
            SelectProps: {
                MenuProps: {
                    classes: {},
                },
            },
        }),
        [classes]
    );

    const defaultProps: Partial<IMuiTextField> = useMemo(
        () => ({
            size: 'small',
            topLabel: true,
            fullWidth: true,
            sx: { width: '100%' },
            InputProps: style.InputProps,
            InputLabelProps: style.InputLabelProps,
        }),
        [style]
    );

    const defaultDisabledProps: Partial<IMuiTextField> = useMemo(
        () => ({
            ...defaultProps,
            disabled: true,
        }),
        [defaultProps]
    );

    const selectProps: Partial<IMuiTextField> = useMemo(
        () => ({
            topLabel: true,
            size: 'small',
            fullWidth: true,
            inputProps: style.inputSelectProps,
            InputProps: style.InputProps,
            InputLabelProps: style.InputLabelProps,
            SelectProps: style.SelectProps,
        }),
        [style]
    );

    return { defaultProps, defaultDisabledProps, style, selectProps, classes };
};
